import api from './api';

const waterReadingService = {
  // Create new water reading
  createReading: (data) => {
    return api.post('/api/water-readings', data);
  },

  // Get all water readings (landlord)
  getAllReadings: (params = {}) => {
    return api.get('/api/water-readings', { params });
  },

  // Get tenant's own readings
  getMyReadings: (params = {}) => {
    return api.get('/api/water-readings/me', { params });
  },

  // Get latest reading for a room
  getLatestReading: (roomId) => {
    return api.get(`/api/water-readings/room/${roomId}/latest`);
  },

  // Generate bill from reading
  generateBill: (readingId) => {
    return api.post(`/api/water-readings/${readingId}/generate-bill`);
  },

  // Get water statistics
  getStatistics: () => {
    return api.get('/api/water-readings/statistics');
  },

  // Delete reading
  deleteReading: (id) => {
    return api.delete(`/api/water-readings/${id}`);
  },
};

export default waterReadingService;
